import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {Col, Form, Row} from "react-bootstrap";
import {Portlet, PortletBody, PortletFooter, PortletHeader} from "../../../components/Portlet";
import FormHookSelect from "../../air/airBooking/components/formHookSelect";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import SearchSelect from "../../../components/searchSelect";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import UploadDocuments from "../../touristServices/components/uploadDocuments";
import ImagesBlock from "../../trips/components/imagesBlock";
import LoadingButton from "../../base/components/loadingButton";
import {Link} from "react-router-dom";
import Galery from "./galery";
import {useController} from "react-hook-form";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";

const AllDocInputs = ({formController, data, prefix, countries,clientId}) => {

  const {
    register,
    formState: {errors},
    control,
    setValue,
    getValues,
    watch
  } = formController

  const [onlyPDF, setOnlyPDF] = useState(_.filter(_.get(getValues(), `${prefix}photos`), (l) => (l.url.includes('.pdf'))))
  const {
    field: {onChange: countryOnChange, value: countryValue}
  } = useController({
    name: `${prefix}country`,
    control,
    rules: {required: true},
  });
  const {
    field: {onChange: genderOnChange, value: genderValue}
  } = useController({
    name: `${prefix}gender`,
    control,
    rules: {required: true},
  });
  const {
    field: {onChange: photosOnChange, value: photosValue}
  } = useController({
    name: `${prefix}photos`,
    control,
    rules: {required: true},
  });

  useEffect(() => {
    console.log('WATCH PHOTOS', watch(`${prefix}photos`))

    setOnlyPDF(_.filter(_.get(getValues(), `${prefix}photos`), (l) => (l.url.includes('.pdf'))))
  }, [watch(`${prefix}photos`)]);

  const deletePDF = (url) => {
    if (window.confirm('Вы уверены что хотите удалить PDF')) {
      const array = _.filter(_.get(getValues(), `${prefix}photos`), (l) => (l.url !== url))
      setValue(`${prefix}photos`, array)
    }
  }

  return (
    <>
      <div>
        <Row>
          <Col sm={6}>
            <Portlet>
              <PortletHeader title={'Документ'}/>
              <PortletBody>
                <Row className={'mb-3'}>
                  <Col sm={4}>
                    <FormHookSelect
                      // defaultValue={data.documentType}
                      register={register(`${prefix}documentType`, {required: true})}
                      errors={errors}
                      label={'Вид документа'}
                    >
                      {documentTypesList.map((val,index)=> {
                        return <option value={val.value} key={index}>{val.label}</option>
                      })}

                    </FormHookSelect>
                  </Col>
                  <Col>
                    <FormHookInput
                      register={register(`${prefix}documentNumber`, {
                        required: true,
                        onBlur:(e)=>{
                          window.history.pushState({}, null, `/counterparty/contacts?id=${clientId}&doc=${e.target.value}`)
                        }})}
                      label={'№ Документа'}
                      // defaultValue={data.documentNumber}
                      errors={errors}
                    />
                  </Col>
                  <Col sm={4}>
                    <SearchSelect
                      onChange={countryOnChange}
                      label={'Страна'}
                      hasError={_.get(errors, `${prefix}country`)}
                      defaultValue={countryValue}
                      array={countries}/>
                  </Col>
                </Row>
                <Row className={'mb-3'}>
                  <Col sm={3}>
                    <CustomDatePicker formController={formController}
                                      label={"Выписан"}
                                      value={data.issueDate}
                                      name={`${prefix}issueDate`}
                                      rules={{required: true}}/>
                  </Col>
                  <Col>
                    <CustomDatePicker formController={formController}
                                      label={"Истекает"}
                                      value={data.expirationDate}
                                      name={`${prefix}expirationDate`}
                                      rules={{required: true}}/>
                  </Col>
                  <Col>
                    <SearchSelect
                      onChange={(v) => {
                        genderOnChange(v)
                      }}
                      label={'Пол'}
                      hasError={_.get(errors, `${prefix}gender`)}
                      defaultValue={genderValue}
                      array={gendersList}/>
                  </Col>
                  <Col>
                    <Form.Label className={'d-flex align-items-center gap-2 pt-2'}>
                      <input
                        defaultChecked={data.infant}
                        {...register(`${prefix}infant`)}
                        type={"checkbox"}
                      />{" "}
                      Младенец
                    </Form.Label>
                  </Col>
                </Row>
                <div className={'d-flex flex-column gap-3'}>
                  <FormHookInput
                    register={register(`${prefix}lastName`, {
                      required: true,
                      onChange: e => {
                        e.target.value = ("" + e.target.value).toUpperCase();
                      }
                    })}
                    label={'Фамилия'}
                    // defaultValue={data.lastName}
                    errors={errors}
                  />
                  <FormHookInput
                    register={register(`${prefix}firstName`, {
                      required: true,
                      onChange: e => {
                        e.target.value = ("" + e.target.value).toUpperCase();
                      }
                    })}
                    label={'Имя'}
                    // defaultValue={data.firstName}
                    errors={errors}
                  />
                  <FormHookInput
                    register={register(`${prefix}middleName`)}
                    label={'Отчество'}
                    // defaultValue={data.middleName}
                    errors={errors}
                  />
                  {data.amadeusString && <p>{data.amadeusString}</p>}
                </div>
                <hr/>
                <h4 className={'mb-0'}>Для загрузки PDF или фото без коррекции</h4>
                <div>Можно загрузить несколько за раз</div>
                <UploadDocuments
                  cb={(v) => {
                  let newArray = [...photosValue]
                  v.forEach(l => {
                    newArray.push({url: l.url})
                  })
                    photosOnChange(newArray)
                  // setValue(`${prefix}photos`, newArray)
                }}
                                 docs={photosValue}
                                 onlylink
                                 folder={'serviceDocs'}/>
                <hr/>
                <h4 className={'mb-0 mt-4'}>Для загрузки фото с возможностью редактирования</h4>
                <div>Редактировать можно только в момент загрузки</div>
                <ImagesBlock
                  formController={formController}
                  prefix={`${prefix}photos`}
                  minLength={1}
                  // onlyLink
                  // linkCb={(l) => {
                  //   // let newArray = [..._.get(getValues(), `${prefix}photos`)]
                  //   // if(!_.find(newArray, {url:l})) {
                  //   //   newArray.push({url: l})
                  //   //   photosOnChange(newArray)
                  //   // }
                  //   // setValue(`${prefix}photos`, newArray)
                  //   // console.log('newArr', newArray)
                  // }}
                  photos={photosValue}
                  active={true}
                />
              </PortletBody>
              {/*<PortletFooter>*/}
              {/*  <div className={'d-flex align-items-center gap-2'}>*/}
              {/*    <LoadingButton title={"Добавить"} type={'button'} onClick={()=>{*/}
              {/*      let newArray = [..._.get(getValues(), `${prefix}photos`)]*/}
              {/*      newArray.push({url: "https://storage.googleapis.com/kayar-prod/test%2F20240729180012135_2176.JPG"})*/}
              {/*      setValue(`${prefix}photos`, newArray)*/}
              {/*    }} loading={false}/>*/}
              {/*  </div>*/}
              {/*</PortletFooter>*/}
            </Portlet>
          </Col>
          <Col>
            <Portlet>
              <PortletBody>
                {onlyPDF.length !== 0 && <>
                  <div>Загруженные PDF:</div>
                  {onlyPDF.map((l, i) => {
                    return <div key={i}> {i + 1}) <Link to={l.url} target={'_blank'}>{l.url}</Link>
                      <i className={"fa fa-trash ml-2"}
                         style={{cursor: 'pointer'}}
                         onClick={() => deletePDF(l.url)}/></div>
                  })}
                  <hr/>
                </>}
                <div>Галерея фото(нажми на фото чтобы увеличить)</div>
                <Galery photos={_.filter(_.get(getValues(), `${prefix}photos`), (l) => (!l.url.includes('.pdf')))}/>
              </PortletBody>
            </Portlet>
          </Col>
        </Row>
      </div>

    </>
  );
};

export default AllDocInputs;

const gendersList = [
  {value: 'M', label: 'Муж.'},
  {value: 'F', label: 'Жен.'}]

export const documentTypesList = [
    {value: 'identification', label: 'Удостоверение'},
    {value: 'passport', label: 'Паспорт'},
    {value: 'visa', label: 'Виза'},
]

